import http from '@services/http'

export default {
  getArticleList(data: object): Promise<any> {
    return http.get('user-api/article/recommend/list', data || {})
  },

  getArticleDetail(data: any): Promise<any> {
    return http.get(`user-api/article/detail/${data.id}`, data || {})
  },

  keywordSearch(data: any): Promise<any> {
    return http.get('user-api/article/keywordSearch', data || {})
  },

  keywordSearchStat(data: any): Promise<any> {
    return http.get('user-api/article/keywordSearchStat', data || {})
  },

  getNewIssueArticleList(data: any): Promise<any> {
    return http.get('user-api/article/issue/newIssueArticleList', data || {})
  },

  getIssueArticleList(data: any): Promise<any> {
    return http.get('user-api/article/issue/issueArticleList', data || {})
  },

  getJournalArticleRecommend(data: any): Promise<any> {
    return http.get('user-api/article/journal/journalArticleRecommend', data || {})
  },

  journalArticleSearch(data: any): Promise<any> {
    return http.get('user-api/article/journal/journalArticleSearch', data || {})
  },

  getKnowledgeGraph(data: any): Promise<any> {
    return http.get(`user-api/article/detail/${data.id}/knowledgeGraph`, data || {})
  },

  getSpecialArticleList(data: object): Promise<any> {
    return http.get('user-api/article/special/articleSearch', data || {})
  }
}
